module.exports = __webpack_public_path__ + "media/images/recruitment/landing/price01-690b903f478d4fabfea6991aa6e8f68a.svg";